import { z } from 'zod'

export const trackClickSchema = z.object({
  type: z.enum(['view', 'interaction']),
})

export type TrackClick = z.infer<typeof trackClickSchema>

const appFunnelSources = [
  'header-modal',
  'footer-badges',
  'smart-banner',
  'event-actions',
  'location-actions',
  'take-someone',
  'app-page',
  'qr-home',
  'qr-modal',
  'app-gate',
  'interest-badge',
  'tab-bar',
  'drop-page',
] as const

export const trackAppFunnelSchema = z.object({
  source: z.enum(appFunnelSources),
  platform: z.enum(['ios', 'android', 'desktop', 'unknown']),
})

export type TrackAppFunnel = z.infer<typeof trackAppFunnelSchema>

export function isAppFunnelSource(value: string): value is TrackAppFunnel['source'] {
  return (appFunnelSources as readonly string[]).includes(value)
}
